'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: ', 'px;\n  height: ', 'px;\n  border-radius: ', 'px;\n  background-color: ', ';\n  border-color: ', ';\n  border-style: solid;\n  border-width: 2px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  overflow: hidden;\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  border-radius: ', 'px;\n  background-color: ', ';\n  border-color: ', ';\n  border-style: solid;\n  border-width: 2px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  overflow: hidden;\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  font-size: ', 'px;\n  color: ', ';\n'], ['\n  font-size: ', 'px;\n  color: ', ';\n']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  width: ', 'px;\n  height: ', 'px;\n  border-radius: ', 'px;\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  border-radius: ', 'px;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _View = require('../View');
var _View2 = _interopRequireDefault(_View);
var _Text = require('../../fundamentals/Text');
var _Text2 = _interopRequireDefault(_Text);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var avatarCircle = function avatarCircle(props) {
  var bgColor = props.bgColor,
    fgColor = props.fgColor,
    otherProps = (0, _objectWithoutProperties3.default)(props, ['bgColor', 'fgColor']); // eslint-disable-line

  return _react2.default.createElement(_View2.default, otherProps, props.children);
};
var AvatarCircle = (0, _styledComponents2.default)(avatarCircle)(_templateObject, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size / 2;
}, function (props) {
  return props.bgColor;
}, function (props) {
  return props.fgColor;
});
var AvatarText = (0, _styledComponents2.default)(_Text2.default)(_templateObject2, function (props) {
  return props.size / 2;
}, function (props) {
  return props.color;
});
var AvatarImage = _styledComponents2.default.img(_templateObject3, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size / 2;
});
var userAvatar = function userAvatar(props) {
  var imageUrl = props.imageUrl,
    alt = props.alt,
    size = props.size,
    bgColor = props.bgColor,
    fgColor = props.fgColor,
    className = props.className;
  return imageUrl ? _react2.default.createElement(AvatarImage, {
    className: className,
    size: size,
    src: imageUrl,
    alt: alt || ''
  }) : _react2.default.createElement(AvatarCircle, {
    className: className,
    size: size,
    bgColor: bgColor,
    fgColor: fgColor
  }, _react2.default.createElement(AvatarText, {
    size: size,
    color: fgColor
  }, alt && alt.substring(0, 1).toUpperCase()));
};
userAvatar.defaultProps = {
  size: 64,
  bgColor: '#d8d8d8',
  fgColor: '#ffffff'
};
userAvatar.propTypes = {
  imageUrl: _propTypes2.default.string,
  alt: _propTypes2.default.string,
  size: _propTypes2.default.number,
  bgColor: _propTypes2.default.string,
  fgColor: _propTypes2.default.string,
  className: _propTypes2.default.string
};
exports.default = userAvatar;